import React from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {
    TextField,
    Grid
} from '@material-ui/core/';
export const Identity = ({ values, errors, onChange }) => {
    return (
        <div>
            <div className="campaign-step-header">
                <Typography variant="h5">
                    Instructions
            </Typography>
            </div>
            <Grid container>
                <Grid item xs={12}>
                    <div>
                        <Typography>
                            More information about brand and product
                            </Typography>
                        <TextField
                            id="identity"
                            label="More information about brand and product"
                            value={values.identity ? values.identity : ''}
                            onChange={onChange}
                            fullWidth
                            multiline
                            rows={4}
                            autoFocus
                            margin="normal"
                            variant="outlined"
                            required={true}
                            error={!!errors.identity}
                            helperText={errors.identity ? errors.identity : ''}
                        />

                    </div>
                    <TextField
                        id="brandWebsite"
                        value={values.brandWebsite ? values.brandWebsite : ''}
                        onChange={onChange}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        error={errors.brandWebsite}
                        label="Brand Website"
                        helperText={errors.brandWebsite ? errors.brandWebsite : ''}
                    />
                    <TextField
                        id="brandInstagramHandle"
                        value={values.brandInstagramHandle ? values.brandInstagramHandle : ''}
                        onChange={onChange}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        label="Brand Instagram handle"
                        error={errors.brandInstagramHandle}
                        helperText={errors.brandInstagramHandle ? errors.brandInstagramHandle : ''}
                    />
                    <TextField
                        id="productImageURL"
                        value={values.productImageURL ? values.productImageURL : ''}
                        onChange={onChange}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        label="Product image (URL)"
                        error={errors.productImageURL}
                        helperText={errors.productImageURL ? errors.productImageURL : ''}
                    />
                </Grid>
            </Grid>
        </div>
    )
}